import { useMutation, useQueryClient } from 'react-query';
import { startMeetingForRoundTemplate } from 'src/apis/meeting';
import {
	AssessmentTokenDetails,
	GetAllMockRoundTemplatesAPIResponse,
	GetPreferenceMeetingsAPIResponse,
	MeetingStatus,
} from 'types';

import { get } from 'lodash'; // Replace with your actual utility function if necessary
import { useNavigate } from 'react-router-dom';
import { useToast } from 'src/context/ToastProvider';

export const useStartMeetingMutation = () => {
	const queryClient = useQueryClient();
	const navigate = useNavigate();
	const toast = useToast();
	return useMutation(['startMeetingForRoundTemplate'], startMeetingForRoundTemplate, {
		onSuccess(data, variables) {
			const { roundTemplateId, isMock } = variables;
			console.log('Data:', data, data.meeting, data.ongoingAssessment);
			if (data?.ongoingAssessment?.interviewUrl) {
				window.open(data.ongoingAssessment.interviewUrl, '_self');
				toast({
					title: 'Meeting Started',
				});
			} else {
				toast({
					title: `Interview Url not found!`,
				});
			}
		},
		onError(error: Error) {
			const errorMessage = get(error, ['response', 'data', 'message'], error.message);
			toast({
				type: 'error',
				title: errorMessage,
			});
		},
	});
};
